export const externalRoutes = {
  FreshdeskTicket: {
    name: "FreshdeskTicket",
    path: "https://soenergy.freshdesk.com/a/tickets/",
  },
  AWSConnect: {
    name: "AWS Connect",
    path: `${import.meta.env.SO_AWS_CONNECT_ORIGIN}/home`,
  },
  Teleopti: {
    name: "Teleopti",
    path: "https://soenergy.teleopticloud.com",
  },
  KnowledgeBase: {
    name: "Knowledge base",
    path: "https://home.so.energy/boards/461",
  },
  PhoneQueues: {
    name: "Phone queues",
    path: "https://wallboard.so.energy",
  },
  ECOES: {
    name: "ECOES",
    path: "https://www.ecoes.co.uk/",
  },
  XOServe: {
    name: "XOServe",
    path: "https://www.xoserveservices.com/",
  },
  ThirdPartyInvestigations: {
    name: "Third Party Call Request Form",
    path: "https://forms.office.com/Pages/ResponsePage.aspx?id=9yXRL1DU20-YbaSClpGMu6UM8_zrkahHkuBIjKRQJ1RUMTlGWDROUjdUMjFFRVlJWDM3OTZBT0I2US4u",
  },
  SmartMeterInterest: {
    name: "Smart meter interest",
    path: "https://soenergy.typeform.com/to/e3Na4EJm",
  },
  DataReqIncident: {
    name: "Data request - Incident",
    path: "https://soenergy.atlassian.net/servicedesk/customer/portal/2/group/8/create/121",
  },
  DataReqOther: {
    name: "Data request - Other",
    path: "https://home.so.energy/posts/2119706-data-subject-requests-sar-erasure-incident-step-by-step",
  },
  WHDApplications: {
    name: "WHD Applications",
    path: `${import.meta.env.SO_ARK_SITE_URL}/warm_home_discount/applications`,
  },
  HomeCoverApplication: {
    name: "Home Cover Application",
    path: "https://soenergy.typeform.com/to/omIygi2J",
  },
  HomeCoverInfoPage: {
    name: "Home Cover Info Page",
    path: "https://home.so.energy/posts/2119874-hometree-home-cover-renewal-offer-process-explained",
  },
  SoGoodToKnowPage: {
    name: "So Good to Know",
    path: "https://soenergygroup.sharepoint.com/SoGoodToKnow/SitePages/Home.aspx",
  },
  ChangeOfTenancyTypeform: {
    name: "Change of tenancy",
    path: "https://soenergy.typeform.com/to/rPtlwK",
  },
  MeteringTroubleshootingArticles: {
    name: "Metering troubleshooting articles",
    path: "https://home.so.energy/series/2119682-series-metering-troubleshooting",
  },
  DCAGuide: {
    name: "DCA guide",
    path: "https://home.so.energy/posts/2119873-debt-collection-agencies-dcas-process-explained",
  },
  SiteworksTasksGuide: {
    name: "Siteworks tasks guide",
    path: "https://home.so.energy/posts/2119672-tasks-guide-siteworks",
  },
  DDHelpPage: {
    name: "DD Help page",
    path: "https://home.so.energy/posts/2119809-taking-card-payments-and-setting-up-direct-debits-over-phone-step-by-step",
  },
  SmexWaitlist: {
    name: "SMEX waitlist",
    path: "https://lookerstudio.google.com/reporting/0d4c851b-14dc-48b7-bd3c-ae0edafb984a/page/tEnnC",
  },
} as const
